// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicTariffZoneControllerGetAllData } from './PublicTariffZoneControllerGetAllData.gen';
import type { PublicTariffZoneControllerGetAllErrors } from './PublicTariffZoneControllerGetAllErrors.gen';
import type { PublicTariffZoneControllerGetAllNetworkTariffZoneData } from './PublicTariffZoneControllerGetAllNetworkTariffZoneData.gen';
import type { PublicTariffZoneControllerGetAllNetworkTariffZoneErrors } from './PublicTariffZoneControllerGetAllNetworkTariffZoneErrors.gen';
import type { PublicTariffZoneControllerGetAllNetworkTariffZoneResponses } from './PublicTariffZoneControllerGetAllNetworkTariffZoneResponses.gen';
import type { PublicTariffZoneControllerGetAllResponses } from './PublicTariffZoneControllerGetAllResponses.gen';
import type { PublicTariffZoneControllerGetMhdZoneTariffZoneData } from './PublicTariffZoneControllerGetMhdZoneTariffZoneData.gen';
import type { PublicTariffZoneControllerGetMhdZoneTariffZoneErrors } from './PublicTariffZoneControllerGetMhdZoneTariffZoneErrors.gen';
import type { PublicTariffZoneControllerGetMhdZoneTariffZoneResponses } from './PublicTariffZoneControllerGetMhdZoneTariffZoneResponses.gen';

export class PublicTariffZoneController {
    /**
     * Get tariff zones.
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicTariffZoneControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicTariffZoneControllerGetAllResponses, PublicTariffZoneControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-zones',
            ...options
        });
    }
    
    /**
     * Get all network tariff zone detail.
     */
    public static getAllNetworkTariffZone<ThrowOnError extends boolean = false>(options?: Options<PublicTariffZoneControllerGetAllNetworkTariffZoneData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicTariffZoneControllerGetAllNetworkTariffZoneResponses, PublicTariffZoneControllerGetAllNetworkTariffZoneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-zones/all-network-tariff-zone',
            ...options
        });
    }
    
    /**
     * Get mhd zone tariff zone detail.
     */
    public static getMhdZoneTariffZone<ThrowOnError extends boolean = false>(options?: Options<PublicTariffZoneControllerGetMhdZoneTariffZoneData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicTariffZoneControllerGetMhdZoneTariffZoneResponses, PublicTariffZoneControllerGetMhdZoneTariffZoneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/tariff-zones/mhd-zone-tariff-zone',
            ...options
        });
    }
}
